import localStorageService from '../../utils/services/localStorage/localStorage';
import { getOptionalLocaleForCMS } from '../../../common/cms/localeValidationUtils';
import { AUTH_APP_LOCALE_LOCAL_STORAGE_KEY } from './authLocaleConstants';

export const getSavedAuthLocale = (): string | null => {
    const value = localStorageService.getItem(AUTH_APP_LOCALE_LOCAL_STORAGE_KEY);
    return getOptionalLocaleForCMS(value);
};

export const saveAuthLocale = (locale: string | null | undefined): void => {
    const normalizedLocale = getOptionalLocaleForCMS(locale);
    if (!normalizedLocale) return;

    localStorageService.setItem(AUTH_APP_LOCALE_LOCAL_STORAGE_KEY, normalizedLocale);
};
